import { render, staticRenderFns } from "./service-status.vue?vue&type=template&id=5e4c2034&scoped=true"
import script from "./service-status.vue?vue&type=script&lang=js"
export * from "./service-status.vue?vue&type=script&lang=js"
import style0 from "./service-status.vue?vue&type=style&index=0&id=5e4c2034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c2034",
  null
  
)

export default component.exports